import { useState, useEffect } from 'react';
import { useDrop } from 'react-dnd';
import Swal from "sweetalert2";
import { IEntries, IRelatorio } from '../../interfaces/IRelatorio';
import RelatoriosService from '../../services/RelatoriosService';
import { IArquivoCardEsteira } from '../../interfaces/IArquivoCardEsteira';
import moment from 'moment';
import { uniqueId } from 'lodash';
import Cartao from './cartao';
import { IEsteira } from '../../interfaces/IEsteira';
import InfiniteScroll from 'react-infinite-scroll-component';
import ImportarService from '../../services/ImportarService';
/*Tradução */
import './../../../i18n/config';
import { useTranslation } from 'react-i18next';
import { formatDefault } from '../../utils/DateUtil';

const ColunaBoard = ({ title, titleIcon, status, esteiraID, dados, showModal, updateAll, onConciliationInteligent, perfil, responsavelContabil, empresaID, esteira, mostrarContaReferencial, loadDataReport, possuiFiltro, loadingMovimentando, conciliando, setConciliando, mensagemSistema, onRequestExtratoBancario, onRequestFolhaPagamento, onMovidoParaConcluido }: { title: String, titleIcon?: React.ReactElement, mostrarContaReferencial: boolean, status: String, esteiraID: number, updateAll: Function, onConciliationInteligent: Function, perfil: String | undefined, empresaID: number, esteira: IEsteira | undefined, responsavelContabil: boolean, dados: IRelatorio[], setDados: Function, loadDataReport: Function, possuiFiltro: boolean, loadingMovimentando: boolean, conciliando: boolean, setConciliando: Function, showModal: Function, mensagemSistema?: any[], onRequestExtratoBancario?: (item: any) => void, onRequestFolhaPagamento?: (item: any) => void, onMovidoParaConcluido?: (codigo: string, id: number) => void }) => {
    const [showBody, setShowBody] = useState<Boolean>(status === 'Arquivado' ? false : true);
    const [loading, setLoading] = useState<boolean>(false);
    const [hasMore, setHasMore] = useState<boolean>(true);
    const [loaded, setLoaded] = useState<boolean>(false);
    const { t } = useTranslation();


    const [, drop] = useDrop(() => ({
        accept: 'CARD',
        drop: async (item: any) => {

            // Bloqueia movimentação enquanto uma conciliação está sendo enviada
            if (conciliando) {
                Swal.fire({
                    text: 'Aguarde a requisição de conciliação em andamento.',
                    timer: 3000,
                    icon: 'warning',
                    showConfirmButton: false
                });
                return;
            }

            const ordemStatus = ['Pendentes', 'Em Processamento', 'Conciliado Parcial', 'Conciliacao', 'Em Conferencia', 'Concluida'];

            const ordemMovendo = ordemStatus.findIndex((i) => i === status);
            let ordemAtual = ordemStatus.findIndex((i) => i === item.status);

            if (ordemAtual < 0 && !item.status) {
                ordemAtual = 0;
            }

            if (ordemAtual > 1 && ordemMovendo <= 1 && status !== "Arquivado") {
                Swal.fire({
                    text: 'Não é possível retornar a conta!!',
                    timer: 3000,
                    icon: 'error',
                    showConfirmButton: false
                });

                return;
            }

            if (item.status === 'Em Conferencia') {
                const promiseDados: Promise<IEntries[]> = new Promise((resolve) => {
                    RelatoriosService.dadosResumidosPorStatusInterno(esteiraID, item.id, 0, 'totalmatch', '', false, (result) => {
                        resolve(result);
                    });
                }) as Promise<IEntries[]>;

                const result = await promiseDados;

                if (result && result.length > 0) {
                    Swal.fire({
                        text: 'Não foi possível mover porque a conta possuí confirmações de conciliação pendentes!!',
                        timer: 5000,
                        icon: 'error',
                        showConfirmButton: false
                    });

                    return;
                }
            }

            if (status === "Concluida" || (item.status === "Concluida" && status !== "Concluida")) {
                if (perfil !== "Administrador" && !responsavelContabil) {
                    Swal.fire({
                        text: 'Apenas administradores ou responsável contábil podem mover para Concluido!!',
                        timer: 3000,
                        icon: 'error',
                        showConfirmButton: false
                    });

                    return;
                }
            }

            if ((item.status === status) || (!item.status && status === "Pendentes")) {
                return;
            }

            if (item.status === "Em processamento") {
                Swal.fire({
                    text: 'Por favor aguarde o processamento da conta!!',
                    timer: 3000,
                    icon: 'error',
                    showConfirmButton: false
                });

                return;
            }

            if (item.status === "Arquivado" && (status !== "Pendentes" && status !== "Em processamento")) {
                Swal.fire({
                    text: 'Contas arquivadas só podem ser movidos para pendentes ou para processamento.',
                    timer: 3000,
                    icon: 'error',
                    showConfirmButton: false
                });

                return;
            }

            if ((item.status === "Pendentes" || !item.status) && (status !== "Em processamento" && status !== "Arquivado")) {
                Swal.fire({
                    text: 'Contas pendentes só podem ser enviadas para processamento ou para lista de arquivados.',
                    timer: 3000,
                    icon: 'error',
                    showConfirmButton: false
                });

                return;
            }

            if (status === "Em processamento" && item.configuracao) {
                const mostrarConfiguracao = () => new Promise((resolve, reject) => {
                    Swal.fire({
                        title: "Configure sua conta",
                        text: 'Digite sua conta referêncial',
                        input: 'text',
                        showCancelButton: true,
                        cancelButtonText: 'Sair',
                        confirmButtonColor: 'green',
                        cancelButtonColor: 'red',
                        confirmButtonText: 'Configurar',
                        showConfirmButton: true
                    }).then(async (result) => {
                        if (result.isConfirmed && result.value) {
                            try {
                                const final = await ImportarService.configurarContaContabil(esteiraID, item.codigo, result.value)
                                resolve(final);
                            } catch (e) {
                                reject(e);
                            }

                        }
                    })
                });


                try {
                    const final: any = await mostrarConfiguracao();
                    item.isBanco = final.isBanco || final.isCaixa;
                    item.isSalario = final.isSalario;
                    item.isFornecedor = final.isFornecedor;
                }
                catch (e) {
                    Swal.fire({
                        text: 'Não foi possível parametrizar seu plano de contas, tente novamente.',
                        timer: 10000,
                        icon: 'error',
                        showConfirmButton: false
                    });
                    return;
                }

            }

            if (status === "Em processamento" && item.isBanco) {
                if (onRequestExtratoBancario) {
                    onRequestExtratoBancario(item);
                }
                return;
            }

            if (status === "Em processamento" && item.isFolha) {
                if (onRequestFolhaPagamento) {
                    onRequestFolhaPagamento(item);
                }
                return;
            }

            if (status === "Em processamento") {
                // Conciliação automática via fila — bloqueia outros drags até a API responder
                setConciliando(true);
                try {
                    await RelatoriosService.conciliar(esteiraID, item.id);
                    updateAll(item.codigo, status);
                } finally {
                    setConciliando(false);
                }
            } else {
                await RelatoriosService.newStatusConta(item.id, esteiraID || 0, status);
                updateAll(item.codigo, status);
            }

            if (status === "Concluida" && onMovidoParaConcluido) {
                onMovidoParaConcluido(item.codigo, item.id);
            }

            if (status === "Conciliacao") {
                onConciliationInteligent(item.codigo);
            }

        }
    }), [title, esteiraID, status, showModal, updateAll, onConciliationInteligent, conciliando, setConciliando, onRequestExtratoBancario, onMovidoParaConcluido]);

    useEffect(() => {
        if (!loaded) {
            setLoading(true);
            loadDataReport(0, status, () => {
                setLoading(false);
            }, setHasMore);
            setLoaded(true);
        }
    }, [loadDataReport, loaded]);


    return (
        <div ref={drop} style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ width: '272px', marginRight: '15px', maxHeight: '350px' }}>
                <div style={{ width: '100%', padding: '15px 10px', display: 'flex', alignItems: 'center', justifyContent: 'start', backgroundColor: '#EBECF0', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}>
                    {status === "Arquivado" && <i className={showBody ? 'fa fa-eye-slash fs-4' : 'fa fa-eye fs-4'} style={{ marginRight: '10px' }} onClick={() => setShowBody((old) => !old)} />}
                    <p style={{ wordBreak: 'break-word', fontSize: '16px', fontWeight: 'bold', margin: '0', marginRight: '5px', textAlign: 'justify' }}>{title}</p>
                    {titleIcon}
                </div>
                {
                    showBody && !loadingMovimentando && !loading && dados.length > 0 && (
                        <div id={`scrollableDiv-${status}`} style={{ width: '100%', maxHeight: '216px', overflow: 'auto' }}>
                            <InfiniteScroll
                                style={{ overflow: 'hidden' }}
                                dataLength={dados.length}
                                next={() => loadDataReport(dados.length, status, () => {
                                    setLoading(false);
                                    setLoaded(true);
                                }, setHasMore)}
                                hasMore={possuiFiltro ? false : hasMore}
                                scrollableTarget={`scrollableDiv-${status}`}
                                loader={<div className='col-md-12 mt-2'>
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                        {t("Aguarde...")}
                                    </span>
                                </div>}
                                endMessage={
                                    <p style={{ textAlign: 'center' }}>
                                        <b>{t("Todos os cards foram carregados")}</b>
                                    </p>
                                }
                                refreshFunction={() => { }}
                                pullDownToRefresh
                                pullDownToRefreshThreshold={50}
                            >
                                {dados.map((item) => (
                                    <Cartao id={item.id} isTributo={item.isTributo} configuracao={!item.contaReferencial} processando={item.processando} porcentagemProcessando={item.porcentagemProcessamento} destacar={item.destacar} key={uniqueId()} secondTitle={`${item.contaReferencial} - ${item.descricaoReferencial}`} mensagemSistema={(mensagemSistema || []).filter((m: any) => m.conta === item.contaEmpresa)} isFornecedor={item.isFornecedor} esteiraID={esteiraID} isSalario={item.isSalario} isBanco={item.isBanco} isFolha={item.isFolha} isContaConciliacaoInteligente={item.contaConciliacaoInteligente} percent={item.status === 'Arquivado' ? null : item.porcentagemConciliado} status={item.status} showModal={showModal} title={item.descricaoEmpresa || item.descricaoReferencial} codigo={item.contaEmpresa} etapaProcessamento={(item as any).etapaProcessamento} totalLancamentos={(item as any).totalLancamentos} pendentesProcessamento={(item as any).pendentesProcessamento} inicioProcessamento={(item as any).inicioProcessamento} usuarioProcessamento={(item as any).usuarioProcessamento} onShowPreview={(afterLoading: any) => {
                                        afterLoading();
                                        window.open(`/capa-conciliacao/${item.id}`, '_blank');
                                    }} onShowPdf={esteira ? (afterLoading: any) => {
                                        RelatoriosService.pegarUrlImpressaoNovo(empresaID, [{
                                            conta: item.contaEmpresa,
                                            id: item.id
                                        }], mostrarContaReferencial, new Date(esteira.periodoInicio), new Date(esteira.periodoFim), (x: Blob) => {
                                            afterLoading();
                                            window.open(URL.createObjectURL(x), '_blank');
                                        });
                                    } : undefined} />
                                ))}
                            </InfiniteScroll>
                        </div>
                    )
                }
                {loading || loadingMovimentando && (
                    <div className='col-md-12 mt-2'>
                        <span className='indicator-progress' style={{ display: 'block' }}>
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            Aguarde...
                        </span>
                    </div>
                )}
            </div>
            <div style={{ width: '272px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'start', backgroundColor: '#EBECF0', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}>
                <p style={{ fontSize: '14px', margin: '0', paddingLeft: '15px', textAlign: 'justify' }}>{t("Total de Contas")}: {dados?.length || 0}</p>
            </div>
        </div>
    )
}

export default ColunaBoard